import { ReactElement } from 'react';
import * as React from 'react';

import styles from './insert.module.scss';

import { Font } from '@utmb/design-system/text/font';

interface InsertProps {
    color: string;
    backgroundColor: string;
    label: string;
    skewDirection?: 'right' | 'left';
}

export const Insert = ({ color, backgroundColor, label, skewDirection }: InsertProps): ReactElement => {
    return (
        <div className={styles.insert + ' ' + (skewDirection === 'left' ? styles.leftInsert : styles.rightInsert)} style={{ background: backgroundColor }}>
            <div className={styles.skew} style={{ background: backgroundColor }} />
            <Font.OxaniumBold color={color} as="span" desktop="16" mobile="16">
                {label}
            </Font.OxaniumBold>
        </div>
    );
};
